module.exports = __webpack_public_path__ + "static/media/newsletter-august-2021-raul-and-lily.26e7487c.jpg";